"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _recompose = require("recompose");

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var img = (0, _glamor.css)({
  display: "block",
  marginBottom: (0, _css.unitRem)(2),
  paddingTop: "37.5%",

  "& img": (0, _glamor.css)(_css.cover, {
    width: "100%"
  })
});

var checkoutSummary = (0, _glamor.css)({
  position: "relative",
  fontSize: (0, _css.unitRem)(0.75),
  color: _css.colors.gray
});

var title = (0, _glamor.css)({
  display: "block",

  fontSize: (0, _css.unitRem)(1),
  fontWeight: 700,
  color: _css.colors.white,

  marginBottom: (0, _css.unitRem)(2)
});

var secondTitle = (0, _glamor.css)({
  display: "block",

  fontSize: (0, _css.unitRem)(1),
  fontWeight: 700,
  color: _css.colors.white,

  marginTop: (0, _css.unitRem)(2),
  marginBottom: (0, _css.unitRem)(0.66)
});

var columns = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var columnTitle = (0, _glamor.css)({
  display: "block",

  fontSize: (0, _css.unitRem)(0.625),
  fontWeight: 700,
  color: _css.colors.gray,
  textTransform: "uppercase",

  marginBottom: (0, _css.unitRem)(1)
});

var details = (0, _glamor.css)({
  color: _css.colors.white,
  lineHeight: 1.4
});

var line = (0, _glamor.css)({
  display: "block",
  fontWeight: 700
});

var city = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(0.25)
});

var linePush = (0, _glamor.css)({
  display: "block",
  marginBottom: (0, _css.unitRem)(1),
  width: "190px"
});

var name = (0, _glamor.css)({
  display: "block"
});

var paragraph = (0, _glamor.css)({
  lineHeight: 1.4,
  marginTop: 0,
  marginBottom: (0, _css.unitRem)(1)
});

var email = (0, _glamor.css)({
  color: _css.colors.white,
  marginLeft: (0, _css.unitRem)(0.25)
});

var CheckoutSummary = function CheckoutSummary(props) {
  return _react2.default.createElement(
    "div",
    { className: checkoutSummary },
    props.img && _react2.default.createElement(
      "span",
      { className: img },
      _react2.default.createElement("img", { alt: "", src: props.img })
    ),
    _react2.default.createElement(
      "span",
      { className: title },
      "Purchase Summary"
    ),
    _react2.default.createElement(
      _Columns2.default,
      { className: columns, n: 2 },
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "span",
          { className: columnTitle },
          "Billing Details"
        ),
        _react2.default.createElement(
          "div",
          { className: details },
          _react2.default.createElement(
            "span",
            { className: name },
            props.name
          ),
          props.address && _react2.default.createElement(
            "span",
            { className: linePush },
            props.address
          ),
          props.address2 && _react2.default.createElement(
            "span",
            { className: linePush },
            props.address2
          ),
          _react2.default.createElement(
            "span",
            { className: line },
            _react2.default.createElement(
              "span",
              null,
              props.postalCode
            ),
            props.city && _react2.default.createElement(
              "span",
              { className: city },
              props.city
            ),
            props.state && _react2.default.createElement(
              "span",
              { className: city },
              props.state
            )
          ),
          _react2.default.createElement(
            "span",
            { className: linePush },
            props.country
          ),
          _react2.default.createElement(
            "span",
            null,
            props.paymentLine
          )
        )
      ),
      props.subscriptionCreatedAt && props.subscriptionNextChargeAt && _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "span",
          { className: columnTitle },
          "Subscription"
        ),
        _react2.default.createElement(
          "div",
          { className: details },
          _react2.default.createElement(
            "span",
            { className: line },
            "Activation date:"
          ),
          _react2.default.createElement(
            "span",
            { className: linePush },
            props.subscriptionCreatedAt
          ),
          _react2.default.createElement(
            "span",
            { className: line },
            "Renews on:"
          ),
          _react2.default.createElement(
            "span",
            { className: linePush },
            props.subscriptionNextChargeAt
          )
        )
      )
    ),
    _react2.default.createElement(
      "p",
      { className: paragraph },
      "An invoice for this purchase has been emailed to you at:",
      " ",
      _react2.default.createElement(
        "span",
        { className: email },
        props.email
      ),
      _react2.default.createElement("br", null),
      "Now, go be creative!"
    ),
    props.qualifiesForRefund ? _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "span",
        { className: secondTitle },
        "Your refund is on its way"
      ),
      _react2.default.createElement(
        "p",
        { className: paragraph },
        "We\u2019re processing your refund for the remaining duration of your subscription period. Refunds can take a little while to process, so hang tight."
      )
    ) : null
  );
};

exports.default = (0, _recompose.lifecycle)({
  componentWillMount: function componentWillMount() {
    return !__SERVER__ && window.scrollTo(0, 0);
  }
})(CheckoutSummary);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckoutSummary/CheckoutSummary.jsx
// module id = 2842
// module chunks = 0